import { Component, OnInit, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { _GlobalConstants } from '../../../services/globalConstants.service';

declare var jQuery:any;
declare var $ :any;
declare var defaultGridViewSettings;
declare var globalConstants;

@Component({
  selector: 'sub-fx-orders-h',
  templateUrl: './sub-fx-orders-h.component.html',
  styleUrls: ['./sub-fx-orders-h.component.css'],
})

export class SubFXOrdersHistory implements OnInit, OnDestroy {

  private subscription: any;
  private globalConstants: any;

  constructor (private route: ActivatedRoute, private titleService: Title, private constants: _GlobalConstants) { }

  ngOnInit() {

    //Set the page title
    this.titleService.setTitle("WiseRisk | Submitted FX Order Event Log");

    this.subscription = this.constants.getGlobalConstants().subscribe((res) => {
      this.globalConstants = res;
      this.globalReady();
    })
  }

globalReady() {

        var initrowdetails = function(index, parentElement, gridElement, datarecord) {

            // Allocations
            var sourceAllocations = {
                localdata : datarecord.allocations,
                datatype : "json",
                datafields : [{
                    name : 'accountCode',
                    type : 'string'
                }, {
                    name : 'currency',
                    type : 'string'
                }, {
                    name : 'quantity',
                    type : 'string'
                }]
            };
            var settingsAllocations = defaultGridViewSettings("#jqxGridAllocations", sourceAllocations);
            settingsAllocations.width = '97%';
            settingsAllocations.height = '99%';
            settingsAllocations.columns = [{
                text : 'Account',
                columntype : 'textbox',
                datafield : 'accountCode',
                width : '15%'
            }, {
                text : 'Ccy',
                columntype : 'textbox',
                datafield : 'currency',
                width : '10%'
            }, {
                text : 'Quantity',
                columntype : 'textbox',
                datafield : 'quantity',
                width : '20%'
            }];

            var gridDiv = $($(parentElement).children()[0]);
            $(gridDiv).jqxGrid(settingsAllocations);
        }

        // initialize jqxGrid
        var sourceExternalFXOrders = {
            datatype : "json",
            datafields : [ {
                name : 'eventTimestamp',
                type : 'date',
                format:'yyyy-MM-dd HH:mm:ss.fff'
            }, {
                name : 'eventUserID',
                type : 'string'
            }, {
    			name : 'eventUserDisplayName',
    			type : 'string'
    		}, {
                name : 'eventIPAddress',
                type : 'string'
            }, {
    			name : 'eventAction',
    			type : 'string'
    		}, {
    			name : 'eventActionDisplayName',
    			type : 'string',
    			value: 'eventAction',
    			values: {
    				source: this.constants.getTranslatedValues('resources.fxOrderEvent.action'),
    				value: 'value',
    				name: 'display'
    			}
    		}, {
                name : 'ruleMatchEventID',
                type : 'string'
            }, {
                name : 'externalOrderID',
                type : 'string'
            }, {
                name : 'timestamp',
                type : 'date',
                format:'yyyy-MM-dd HH:mm:ss.fff'
            }, {
                name : 'currencyPair',
                type : 'string'
            }, {
                name : 'currency',
                type : 'string'
            }, {
                name : 'valueDate',
                type : 'date',
                format : 'yyyy-MM-dd'
            }, {
                name : 'contractType',
                type : 'string'
            }, {
                name : 'contractTypeDisplayName',
                type : 'string',
                value: 'contractType',
                values: {
                    source: this.constants.getTranslatedValues('resources.fxInstrument.type'),
                    value: 'value',
                    name: 'display'
                }
            }, {
                name : 'side',
                type : 'string'
            },  {
    			name : 'sideDisplayName',
    			type : 'string',
    			value: 'side',
    			values: {
    				source: this.constants.getTranslatedValues('resources.order.side'),
    				value: 'value',
    				name: 'display'
    			}
            }, {
                name : 'orderQuantity',
                type : 'string'
            }, {
                name : 'orderSpotPrice',
                type : 'string'
            }, {
                name : 'orderForwardPoints',
                type : 'string'
            }, {
                name : 'orderOutrightPrice',
                type : 'string'
            }, {
                name : 'allocations',
                type : 'array'
            }],
            id : 'eventID',
            url : '/ajax/external-fx-orders/events',
            type : 'GET',
            async : true
        };
        var settingsExternalFXOrders = defaultGridViewSettings("#jqxGrid", sourceExternalFXOrders);
        settingsExternalFXOrders.columns = [ {
            text : 'Timestamp',
            columntype : 'datetimeinput',
            datafield : 'eventTimestamp',
            cellsformat : 'MM/dd/yyyy HH:mm:ss.fff',
            width : '160'
        }, {
            text : 'User',
            columntype : 'textbox',
            datafield : 'eventUserDisplayName',
            width : '100'
        }, {
            text : 'IP Address',
            columntype : 'textbox',
            datafield : 'eventIPAddress',
            width : '80'
        }, {
    		text : 'Action',
    		columntype : 'textbox',
    		datafield : 'eventActionDisplayName',
    		width : '100'
    	}, {
            text : 'External Order ID',
            columntype : 'textbox',
            datafield : 'externalOrderID',
            width : '130'
        }, {
            text : 'External Timestamp',
            columntype : 'datetimeinput',
            datafield : 'timestamp',
            cellsformat : 'MM/dd/yyyy HH:mm:ss.fff',
            width : '160'
        }, {
            text : 'Ccy Pair',
            columntype : 'textbox',
            datafield : 'currencyPair',
            width : '80'
        }, {
            text : 'Ccy',
            columntype : 'textbox',
            datafield : 'currency',
            width : '50'
        }, {
            text : 'Contract Type',
            columntype : 'textbox',
            datafield : 'contractTypeDisplayName',
            width : '100'
        }, {
            text : 'Side',
            columntype : 'textbox',
            datafield : 'sideDisplayName',
            width : '50'
        }, {
            text : 'Quantity',
            columntype : 'textbox',
            datafield : 'orderQuantity',
            width : '100'
        }, {
            text : 'Order Spot Px',
            columntype : 'textbox',
            datafield : 'orderSpotPrice',
            width : '120'
        }, {
            text : 'Order Fwd Pts',
            columntype : 'textbox',
            datafield : 'orderForwardPoints',
            width : '100'
        }, {
            text : 'Order Outright Px',
            columntype : 'textbox',
            datafield : 'orderOutrightPrice',
            width : '100'
        }, {
            text : 'Value Date',
            columntype : 'datetimeinput',
            datafield : 'valueDate',
            cellsformat : 'yyyy-MMM-dd',
            width : '80'
        }];
        settingsExternalFXOrders.rowdetails = true;
        settingsExternalFXOrders.initrowdetails = initrowdetails;
        settingsExternalFXOrders.rowdetailstemplate = {
            rowdetails : "<div id='jqxGridAllocations' style='overflow: hidden;'></div>",
            rowdetailsheight : 300,
            rowdetailshidden : true
        };

        $("#jqxGrid").jqxGrid(settingsExternalFXOrders);

    }

    ngOnDestroy() {
      this.subscription.unsubscribe();
    }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/history/sub-fx-orders-h/sub-fx-orders-h.component.ts